export enum SenderType {
  Unknown = 0,
  Passenger = 1,
  Support = 2,
  Admin = 3
}

export enum ViewState {
  None = 0,
  Send = 1,
  Viewed = 2
}

export interface Attachment {
  fileName: string;
  fileUrl: string;
  thumbnailUrl?: string;
}

export interface ChatMessage {
  id?: number;
  sender: string;
  timestamp: string;
  type: 'text' | 'file' | 'image' | 'system' | 'factor';
  content: string;
  senderType: number;
  attachments: Attachment[];
  viewState?: ViewState;
}

export interface ChatMessagesResponse {
  messages: ChatMessage[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  hasMore: boolean;
}

export interface AddChatMessageRequest {
  tripId: string;
  content: string;
  type: 'text' | 'file' | 'image' | 'system';
  senderType: number;
  attachments: Attachment[];
  viewState?: ViewState;
}

export interface GetChatMessagesRequest {
  tripId: string;
  pageNumber: number;
  pageSize: number;
}
